<template>
  <table class="tableClass">
    <thead class="data-table-header">
      <tr class="topHeader">
        <th class="thChildren">Topology</th>
        <th class="thChildren">Served</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren">Revenue</th>
        <th class="thChildren"></th>
        <th class="thChildren">Cost</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren">Increment Cost</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren">Length</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren">Count</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>

      </tr>
      <tr class="middleHeader">
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">AREA</th>
        <th class="thChildren">TARGET</th>
        <th class="thChildren">SERVER</th>
        <th class="thChildren">CLIENTS</th>
        <th class="thChildren">BUSINESS</th>
        <th class="thChildren">PRIVATE</th>
        <th class="thChildren">SUM</th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">IN %</th>
        <th class="thChildren">NPV</th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">IN %</th>
        <th class="thChildren">STREET SIDES</th>
        <th class="thChildren"></th>
        <th class="thChildren">STREET CROSSINGS</th>
        <th class="thChildren"></th>
        <th class="thChildren">PRIVATE</th>
        <th class="thChildren">RAIL CROSSINGS</th>
        <th class="thChildren">DUCT POTENTIAL</th>
        <th class="thChildren">SERVER</th>
        <th class="thChildren">SUM</th>
        <th class="thChildren">IN %</th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">PER NPV</th>
        <th class="thChildren">DELTA</th>
        <th class="thChildren"></th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren">STREET SIDES</th>
        <th class="thChildren"></th>
        <th class="thChildren">STREET CROSSINGS</th>
        <th class="thChildren"></th>
        <th class="thChildren">PRIVATE</th>
        <th class="thChildren">DUCT POTENTIAL</th>
        <th class="thChildren">SUM</th>
        <th class="thChildren">IN %</th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">PER NPV</th>
        <th class="thChildren">STREET CROSSINGS</th>
        <th class="thChildren"></th>
        <th class="thChildren">RAIL CROSSINGS</th>
      </tr>
      <tr class="bottomHeader">
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren"></th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren">Urban</th>
        <th class="thChildren">Rural</th>
        <th class="thChildren">Urban</th>
        <th class="thChildren">Rural</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren">Cost</th>
        <th class="thChildren">NPV</th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;">PER NPV</th>
        <th class="thChildren">Urban</th>
        <th class="thChildren">Rural</th>
        <th class="thChildren">Urban</th>
        <th class="thChildren">Rural</th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren"></th>
        <th class="thChildren" style="border-right: 2px dotted #67A0B4;"></th>
        <th class="thChildren">Urban</th>
        <th class="thChildren">Rural</th>
        <th class="thChildren"></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in rows" class="Row" :style="{ backgroundColor: colors[index] }">
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">-</td>
        <td class="thChildren">{{ row.served.children.target.value }}</td>
        <td class="thChildren">{{ row.served.children.server.value }}</td>
        <td class="thChildren">{{ row.served.children.clients.value }}</td>
        <td class="thChildren">{{ row.served.children.business.value }}</td>
        <td class="thChildren">{{ row.served.children.private.value }}</td>
        <td class="thChildren">{{ row.served.children.sum.value }}</td>
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">{{ row.served.children.in_percentage.value }}</td>
        <td class="thChildren">{{ row.revenue.children.npv.value }}</td>
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">{{ row.revenue.children.in_percentage.value }}</td>
        <td class="thChildren">{{ row.cost.children.street_sides.children.urban.value }}</td>
        <td class="thChildren">{{ row.cost.children.street_sides.children.rural.value }}</td>
        <td class="thChildren">{{ row.cost.children.street_crossings.children.urban.value }}</td>
        <td class="thChildren">{{ row.cost.children.street_crossings.children.rural.value }}</td>
        <td class="thChildren">{{ row.cost.children.private.value }}</td>
        <td class="thChildren">{{ row.cost.children.rail_crossings.value }}</td>
        <td class="thChildren">{{ row.cost.children.duct_potential.value }}</td>
        <td class="thChildren">{{ row.cost.children.server.value }}</td>
        <td class="thChildren">{{ row.cost.children.sum.value }}</td>
        <td class="thChildren">{{ row.cost.children.in_percentage.value }}</td>
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">{{ row.cost.children.private.value }}</td>
        <td class="thChildren">{{ row.incremental_cost.children.delta.children.cost.value }}</td>
        <td class="thChildren">{{ row.incremental_cost.children.delta.children.npv.value }}</td>
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">{{ row.incremental_cost.children.delta.children.per_npv.value }}</td>
        <td class="thChildren">{{ row.length.children.street_sides.children.urban.value }}</td>
        <td class="thChildren">{{ row.length.children.street_sides.children.rural.value }}</td>
        <td class="thChildren">{{ row.length.children.street_crossings.children.urban.value }}</td>
        <td class="thChildren">{{ row.length.children.street_crossings.children.rural.value }}</td>
        <td class="thChildren">{{ row.length.children.private.value }}</td>
        <td class="thChildren">{{ row.length.children.duct_potential.value }}</td>
        <td class="thChildren">{{ row.length.children.sum.value }}</td>
        <td class="thChildren">{{ row.length.children.in_percentage.value }}</td>
        <td class="thChildren" style="border-right: 2px dotted #67A0B4;">{{ row.length.children.per_npv.value }}</td>
        <td class="thChildren">{{ row.count.children.street_crossings.children.urban.value }}</td>
        <td class="thChildren">{{ row.count.children.street_crossings.children.rural.value }}</td>
        <td class="thChildren">{{ row.count.children.rail_crossings.value }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "AtesioTable",

  props: {
    rows: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style scoped>
.tableClass {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
  font-family: Arial, sans-serif;
}

.data-table-header {
  background-color: #f5f5f5;
  white-space: nowrap;
  width: auto;
}

.topHeader,
.bottomHeader {
  background-color: #fff;
  color: #767676;
  font-family: Lato;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 9px; /* 112.5% */
}

.middleHeader {
  background-color: rgba(103, 160, 180, 0.25);
  color: #767676;
  font-family: Lato;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px; /* 125% */
  text-transform: uppercase;
}

.thChildren,
td {
  padding: 8px;
  text-align: left;
}

.Row {
  color: #767676;
  font-family: Lato;
  font-size: 8px;
  font-style: normal;
  font-weight: 600;
  line-height: 9px; /* 112.5% */
}
</style>



// WEBPACK FOOTER //
// src/components/Npv/Configuration/components/AtesioTable.vue